// extracted by mini-css-extract-plugin
module.exports = {"top":"Layout_top__17iBH","topBottomGutter":"Layout_topBottomGutter__2MWOm"};